import React from 'react';
import {
  FDBodyText, FDClickableText, FDIcon, FDPaper,
  FDSecondaryActionButton, FDStack, FDTitleText,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { displayErrorMessageWithChecks } from 'Context/SnackbarContext/utils';
import { dataAttrs } from 'Helpers/Testing';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';

function ExpenseSummaryGroup({ groupResource }) {
  const {
    setOnboardingStepCollection,
  } = useSurveyContext();
  const { displayErrorMessage } = useSnackbarContext();

  const onEdit = async (rel) => {
    try {
      const onboardingStepCollection = await rel.link('related').get();
      setOnboardingStepCollection(onboardingStepCollection);
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Failed to edit expenses');
    }
  };

  return (
    <FDPaper
      width={'100%'}
      padding={4}
    >
      <FDStack direction={'column'} spacing={2} {...dataAttrs('expense-summary-group-itemized')}>
        <FDStack direction={'row'} justifyContent={'space-between'} spacing={1} alignItems={'center'}>
          <FDTitleText size={'lg'} value={groupResource.attr('title')} color={'textSecondary'} />
          {groupResource.withRelationship(fr.relationships.edit.name, (rel) => (
            <FDSecondaryActionButton
              size={'sm'}
              label={rel.meta('prompt')}
              onClick={() => onEdit(rel)}
              {...dataAttrs('expense-summary-group-itemized-edit-button')}
            />
          ),
          () => null)}
        </FDStack>
        {groupResource.attr('items').resources().list().map((item) => {
          return (
            <FDStack
              direction={'row'}
              spacing={1}
              justifyContent={'space-between'}
              alignItems={'center'}
              key={item.id()}
              {...dataAttrs('expense-summary-group-itemized-item')}
            >
              <FDStack direction={'row'} spacing={1}>
                <FDIcon icon={groupResource.attr('icon')} alignSelf={'center'} />
                <FDBodyText value={item.attr('title')} />
              </FDStack>
              <Richtext value={item.attr('description')} richtext Component={FDBodyText} />
            </FDStack>
          );
        })}
        {groupResource.withRelationship(fr.relationships.noItems.name, (rel) => {
          return (
            <FDStack direction={'column'} spacing={1} alignItems={'center'} paddingY={2}>
              <FDIcon color={'secondary'} icon={'squareListRegular'} size={'lg'} />
              <FDBodyText value={'No expenses were entered.'} />
              <FDClickableText
                appearance={'standalone'}
                label={rel.meta('prompt')}
                onClick={() => onEdit(rel)}
              />
            </FDStack>

          );
        },
        () => null)}
      </FDStack>
    </FDPaper>
  );
}

ExpenseSummaryGroup.propTypes = {
  groupResource: PropTypes.instanceOf(fr.Resource).isRequired,
};

ExpenseSummaryGroup.defaultProps = {
};

export default ExpenseSummaryGroup;
